import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';

import styles from "./ResetPassword.module.css"
import ResetPasswordForm from '../../components/Forms/Signup/ResetPasswordForm';
import RequestResetPasswordForm from '../../components/Forms/Signup/RequestResetPasswordForm';
import { setBackButtonLink } from '../../app/features/headerUISlice';
import { useGetQueryParam } from '../../utils/utilityHooks';
import {
    HeroSectionBottomRightRock,
    HeroSectionLeftRock,
    HeroSectionTopRightRock
} from '../../assets/images/icons';

function ResetPassword() {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const passwordToken = useGetQueryParam('token');

    useEffect(() => {
        dispatch(setBackButtonLink('/login'));

        // Optionally, reset the visibility when the component unmounts
        return () => {
            dispatch(setBackButtonLink(false));
        };
    }, [dispatch]);

    return (
        <>
            <Helmet>
                <title>FindCV - Reset Password</title>
            </Helmet>
            <div className={styles.entityWrapper} >
                <div className={styles.backgroundLayer}></div>
                <img src={HeroSectionLeftRock} className={styles.HeroSectionCircle1} alt="Decorative rock on the left in the Hero section" />
                <img src={HeroSectionTopRightRock} className={styles.HeroSectionCircle2} alt="Decorative rock on the top-right in the Hero section" />
                <img src={HeroSectionBottomRightRock} className={styles.HeroSectionCircle3} alt="Decorative rock on the bottom-right in the Hero section" />
                <div className={styles.formContainer}>
                    <p className={`${styles.entityHeading} ${styles.entityTitle}`}>{t('resetPassword.heading')}</p>
                    <p className={styles.signupText}>{t('resetPassword.description')}</p>
                    {!passwordToken && <RequestResetPasswordForm className={styles.resetPasswordContainer} />}
                    {passwordToken && <ResetPasswordForm passwordToken={passwordToken} className={styles.resetPasswordContainer} />}
                </div>
            </div>
        </>
    );
}

export default ResetPassword;